import { jsx as _jsx } from "react/jsx-runtime";
export function Badge({ count, muted = false, hideZero = true, max = 99, style, }) {
    if (count <= 0 && hideZero)
        return null;
    const label = count > max ? `${max}+` : String(count);
    const base = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '20px',
        height: '20px',
        padding: '0 6px',
        borderRadius: 'var(--radius-pill)',
        background: muted ? 'var(--color-unread-muted)' : 'var(--color-unread)',
        color: 'var(--color-text-inverse)',
        fontSize: 'var(--font-xs)',
        fontWeight: 'var(--weight-semibold)',
        lineHeight: '1',
        ...style,
    };
    return (_jsx("span", { "data-badge": "", "data-muted": muted ? '' : undefined, style: base, children: label }));
}
//# sourceMappingURL=Badge.js.map